import { getFaqListAction } from "../../../Actions/LogicActions/NeedHelp/GetFaqsAction";
import { getListOfServiceRequestAction } from "../../../Actions/LogicActions/ServiceRequestDetails/GetListOfServiceRequestAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { isActionRunSuccessfully } from "../../../Lib/Utils/validationUtil";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { srReqClaimTree } from "../../../Orchestrator/ConstantTree/ServiceRequestClaim/ServiceRequestClaim";
import { IGetFaqListActionParams } from "../../../Orchestrator/Types/Interface/INeedHelp";
import { ServiceRequestClaimDetailsContext } from "../../ServiceRequestClaimDetails/Context/ServiceRequestClaimDetailsContext";
import { NeedHelpContext } from "../Context/NeedHelpContext";

class NeedHelpInitStep extends StepFlow {
  get stepName() {
    return "NeedHelpInit_Step";
  }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on<IGetFaqListActionParams, void>({
        eventName: evtTree.NeedHelp.Faq.Get,
        handler: async ({ data }) => {
          if (data?.intl) {
            await getFaqListAction.setParams(data);
            const context = this.getCtx<NeedHelpContext>("needHelpContext");
            if (context) {
              context.faqLoading = true;
            }
            await getFaqListAction.execute();
          }
        },
      })
    );
    this.registerEventSubscription(
      _eventBus.on<string, void>({
        eventName: evtTree.NeedHelp.Get.TicketList,
        handler: async ({ data }) => {          
          getListOfServiceRequestAction.setParams({ bookingId: data || "" })
          await getListOfServiceRequestAction.execute();
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on<string, void>({
        eventName: srReqClaimTree.RequestClaim.ClaimDetail,
        handler: async ({ data }) => {
          _eventBus.emit({
            eventName: "FLOW_CLOSE",
            data: "NeedHelpFlow",
          });
          _eventBus.emit({
            eventName: "ROUTE_CHANGE",
            data: `/service-request-details${data ? '?bookingId=' + data : ""}`
          })
        }
      })
    )
  }

  async onExecute(): Promise<void> {
    console.log("Need Help Init Step Execute.............................");
    // Run the event to get the banner session
    // _eventBus.emit({
    //   eventName: evtTree.NeedHelp.Faq.Get,
    //   data: {},
    // });
    // sessionStorage.setItem("hideBanner", "true");
    /**
     * Below code is to handle auto open destination popup for location selection
     * From Origin step it's return a init step of search
     * Here in init we check origin is already selected then tear down the init step automatically
     * and it's start destination step.
     */
    _eventBus.emit({
      eventName: evtTree.NeedHelp.FlowStarted
    })
  }
}

export const NeedHelpInitStepDeclaration = new StepDefinition({
  stepName: "NeedHelpInit_Step",
  stepClass: NeedHelpInitStep,
});
